<template>
  <div id="bank-account-view">
    <v-layout row wrap>
      <v-flex offset-xs2 xs8>
        <v-layout row wrap>
          <v-flex xs12>
            <v-list dark>
              <v-list-tile @click="$emit('handle-event', {newBankAccount: true})">
                <v-list-tile-content>
                  <v-list-tile-title>{{i18n('Nova Conta Bancária')}}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn icon ripple data-testid="new-transaction-new-account-button">
                    <v-icon color="grey lighten-1">navigate_next</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile v-for="bank_account in subjectBankAccounts" :key="bank_account.id"  @click="$emit('handle-event', {selectedBankAccount: bank_account})">
                <v-list-tile-content>
                  <v-list-tile-sub-title>{{bankAccountTitle(bank_account)}}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn icon ripple data-testid="new-transaction-subject-bank-account-item">
                    <v-icon color="grey lighten-1">navigate_next</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <div class="buttons-container">
      <v-btn class="default-button" color="#BCC1D1" dark @click="$emit('handle-event', {back: true})">
        {{i18n('Voltar')}}
      </v-btn>
    </div>
  </div>
</template>

<script>
import utils from '../../shared/Utils'

export default {
  name: 'BankAccountView',
  props: {
    subject: {
      type: Object
    },
    operation: {
      type: String
    },
    operationFlow: {
      type: String
    },
    fromCurrency:{
      type: String
    },
    toCurrency: {
      type: String
    }
  },
  data() {
    return {
      loadedSubjectBankAccountStatus: 'not_loaded',
      subjectBankAccounts: []
    }
  },
  mounted() {
    let url = ''
    switch(this.operation) {
      case 'receive':
      case 'withdrawal_internal':
        url = this.$root.urls.bank_accounts
        break
      default:
        url = this.$root.urls.customer__subject__bank_accounts.split('ID').join(this.subject.id)
    }
    this.loadBankAccounts(url)
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    loadBankAccounts(url) {
      let successCallback = (response) => {
        this.loadedSubjectBankAccountStatus = 'ok'
        if (response.body.data) {
          const currency = this.toCurrency
          const operation_flow = this.operationFlow
          const exclude_internal = this.operation == 'withdrawal_internal' ? true : false
          const filter = (record) => {
            if (operation_flow == 'both') {
              return ( record.currency == currency && (exclude_internal == false || !record.internal))
            }
            return (
              record.currency == currency && (exclude_internal == false || !record.internal) &&
              (!record.internal || !record.flow_type || record.flow_type == operation_flow)
            )
          }
          this.$set(this, 'subjectBankAccounts', response.body.data.filter(filter))
        }
      }
      let errorCallback = (response) => {
        if (response.status === 401) {
          this.loadedSubjectBankAccountStatus = 'not_authorized'
        } else {
          this.loadedSubjectBankAccountStatus = 'error'
        }
      }

      this.subjectBankAccounts = []
      let token = this.$cookies.get('api_token')
      this.$http.get(url, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
    bankAccountTitle(bank_account) {
      return utils.longAccountName(bank_account)
    }
  }
}
</script>

<style>
#bank-account-view {
  margin-top: 30px;
}

#bank-account-view .select-document-type {
  display: flex;
  justify-content: center;
}

.isActive,
#bank-account-view .v-input--is-label-active .v-label  {
  color: var(--primary-light-font-color) !important;
}
#bank-account-view .v-input--switch__track {
    color: var(--primary-button-background-color) !important;
}
#bank-account-view .v-input--switch__thumb {
    color: var(--secondary-button-background-color);
}
#bank-account-view .v-input--switch .accent--text {
    color: var(--secondary-button-background-color);
    caret-color: transparent;
}
#bank-account-view .v-input--switch .v-input--selection-controls__ripple {
    left: -14px;
    top: calc(50% - 24px);
    color: var(--secondary-button-background-color);
}
#bank-account-view .v-input--switch .v-input--selection-controls__input{
	width: 45px;
	margin-right: 10px;
  bottom: 10%;
}
#bank-account-view .v-input--switch__track{
	width: 40px;
	height: 26px;
	top: calc(50% - 13px);
	left: 0;
	right: 0;
	border-radius: 13px;
}
#bank-account-view .select-document-type label{
  color: #BCC1D1 !important;
}

#bank-account-view .search-input .v-input__icon--append i{
  color: #27DABC;
}

#bank-account-view h6 {
  font-size: 16px
}

#bank-account-view .v-list {
  background: #0C2E4A;
  border-radius: 4px 4px 0 0;
  padding: 0 0;
}
#bank-account-view .v-list__tile {
  background: #0C2E4A;
}
#bank-account-view .v-list__tile:not(.list-active):hover {
  background: rgb(14, 51, 82);
}
#bank-account-view .list-active {
  background: rgb(28, 75, 114);
}
#bank-account-view .v-list__group::before,
#bank-account-view .v-list__group::after {
  background: none;
}
#bank-account-view .v-list__group .v-list__group__items .v-list__tile {
  padding-left: 12px;
  background: #213F57;
}
#bank-account-view .v-list__group .v-list__group__items .v-list__tile:not(.list-active):hover {
  background: #264864;
}
#bank-account-view .v-list__group .v-list__group__items .v-list__tile.list-active {
  background: #38566E;
}

#bank-account-view .v-list__group .v-list__group__items .v-list__tile__title {
  color: #BCC1D1;
  text-transform: uppercase;
  font-size: 14px;
}
</style>




// WEBPACK FOOTER //
// src/components/NewTransaction/BankAccountView.vue